import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadges = () => {
  const badges = [
    {
      icon: 'Shield',
      label: 'SSL Encrypted',
      description: 'Enterprise-grade security'
    },
    {
      icon: 'Lock',
      label: 'Secure Access',
      description: 'Magic link authentication'
    },
    {
      icon: 'CheckCircle',
      label: 'Verified',
      description: 'Corporate authentication'
    }
  ];

  return (
    <div className="flex flex-wrap items-center justify-center gap-4 mt-8">
      {badges?.map((badge, index) => (
        <div
          key={index}
          className="flex items-center space-x-2 px-4 py-2 bg-success/10 text-success rounded-md"
        >
          <Icon name={badge?.icon} size={16} strokeWidth={2} />
          <div className="flex flex-col">
            <span className="text-xs font-semibold">{badge?.label}</span>
            <span className="text-[10px] opacity-80">{badge?.description}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SecurityBadges;